import Design1 from './design-1';

SpacerBlock.propTypes = {
};

SpacerBlock.defaultProps = {};

export default function SpacerBlock(props) {
    switch (props.settings?.design) {
        case 0 :
            return (<Design1 {...props} />);
        default:
            return (<Design1 {...props} />);
    }
};